import IconInfo from "./IconInfo";
import Filters from "./Filters";

function SidePanel({ data, clickSelection, setDepth, connectionChains,
  setClickSelection, setChainSelection, chainSelection, chartClicked,
  landschapOptions, partijenOptions, setLandschapOptions, setPartijenOptions }) {


  return (
    <div className="SidePanel">

      <IconInfo data={data} clickSelection={clickSelection}
        setClickSelection={setClickSelection} setChainSelection={setChainSelection}
        connectionChains={connectionChains} chainSelection={chainSelection}
        chartClicked={chartClicked} />

      <Filters setDepth={setDepth} data={data} clickSelection={clickSelection}
        connectionChains={connectionChains} chainSelection={chainSelection}
        partijenOptions={partijenOptions} setPartijenOptions={setPartijenOptions}
        landschapOptions={landschapOptions} setLandschapOptions={setLandschapOptions} />

    </div>
  );
}

export default SidePanel;
